/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class IndividualKpiBase {
    getFixupPrototypeFunction() { return IndividualKpiBase.fixupPrototype; }

    static newInstance(model: Partial<IndividualKpiBase>): IndividualKpiBase {
        let obj = Object.assign(new IndividualKpiBase(), model);
        IndividualKpiBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<IndividualKpiBase>): IndividualKpiBase {
        if (!model) return null;
        return IndividualKpiBase.newInstance(<IndividualKpiBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: IndividualKpiBase) {
        if (!obj) return;

        models.IndividualKpiBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: IndividualKpiBase): boolean {
        Object.setPrototypeOf(obj, IndividualKpiBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.supported_resources === undefined) {
            this.supported_resources = 0;
        }
        if (this.maximum_utilized_resources === undefined) {
            this.maximum_utilized_resources = 0;
        }
        if (this.minimum_utilized_resources === undefined) {
            this.minimum_utilized_resources = 0;
        }
        if (this.partially_utilized_resources === undefined) {
            this.partially_utilized_resources = 0;
        }
        if (this.average_utilization_for_resources === undefined) {
            this.average_utilization_for_resources = 0;
        }
    }

    /**
     * Name of the metric for which kpi needs to be shown.
     */
    name: models.MetricNamesForKpi;

    /**
     * Total number of resources for which the dashboard needs to present the data.
     */
    supported_resources: number;

    /**
     * Number of resources which has crossed the high utilization base condition.
     */
    maximum_utilized_resources: number;

    /**
     * Number of resources which has fallen under the minimum utilization base condition.
     */
    minimum_utilized_resources: number;

    /**
     * Number of resources which has been partially utilized.
     */
    partially_utilized_resources: number;

    /**
     * Average Utilization Crossed for the instance/vm.
     */
    average_utilization_for_resources: number;

}
